import axiosInstance from "./axiosConfig";
const TOKEN_KEY = "token";



export const authApi = {
  async login(username, password) {
    try {
      const response = await axiosInstance.post("/login", {
        username,
        password,
      });
      const token = response.data?.token;
      if (token) {
        localStorage.setItem(TOKEN_KEY, token);
      }
      return { data: response, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  },

  async logout() {
    try {
      const response = await axiosInstance.post("/logout");
      localStorage.removeItem(TOKEN_KEY);
      return { data: response, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  },

  async me() {
    try {
      const response = await axiosInstance.get("/me");
      return { data: response, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  },
  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  },

  async getUserLocal() {
    try {
      const dataUser = JSON.parse(localStorage.getItem('user'));
      return dataUser;
    } catch (error) {
      return error;
    }
  }
  

};
